import catalogentries from "./submodules/catalogentries";
import utils from '@/stores/utils';

const { getStorageKey } = utils;

const state = {
    search: "",
    product: null,
};

const mutations = {
    updateSearch(state, search) {
        state.search = search;
    },
    updateProduct(state, product) {
        state.product = product;
    },
    resetState(state) {
        state.search = "";
        state.product = null;
    },
};

const actions = {
    async init({ commit, dispatch, state }, params) {
        // Reset du state
        await commit("resetState");
        
        if (params?.product) {
            await commit("updateProduct", params.product);
            await dispatch("catalogentries/init", {
                filters: { product: params.product.id },
                fetch_stats: false,
            });
            dispatch('catalogentries/fetchCatalogEntries');
        }
    },
};

export default () => ({
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        catalogentries: catalogentries({
            storageKey: getStorageKey('product-sales-prices', 'catalogentries'),
            fieldsToSave: ['limit', 'ordering']
        }),
    },
});
